import { useEffect } from 'react'
import { useNavigate } from 'react-router-dom'
import { trackInternalEvent } from '@rio/tracking'
import { useMediaQueries } from 'builder/hooks/useMediaQueries'

import { InfoBox, SuccessBox } from '../../'
import { WidgetTheme } from '../../WidgetTheme'
import { WidgetProps } from '../../widget.types'
import { WidgetContainer, WidgetBox } from '../../widget.styles'

import { useThemeConfig } from '../../hooks/useThemeConfig'
import { useUpskillConfig } from './hooks/useUpskillConfig'
import { useUpskillActions } from './hooks/useUpskillActions'
import { IlustrationBox } from './IlustrationBox'

import * as Styles from './styles'
import UpskillImage from './assets/upskill.png'
import UpskillMobileImage from './assets/upskill-mobile.png'

export const Upskill = ({ service }: WidgetProps) => {
  const navigate = useNavigate()
  const { isPhone } = useMediaQueries()
  const theme = useThemeConfig({ service })
  const { text, status } = useUpskillConfig(service)
  const { handleClickCourse, handleExploreCourses } = useUpskillActions()

  const isProgress = status === 'progress'
  const isCompleted = status === 'completed'
  const src = isPhone ? UpskillMobileImage : UpskillImage

  const handleClick = () => {
    trackInternalEvent('progress_cta_click', {
      score: service.title,
      cta: text.actionText,
    })
    if (isCompleted) {
      navigate(service.getNextActionUrl())
    } else if (isProgress) {
      if (!service?.data?.last_course?.cmsgid) return
      handleClickCourse(service?.data?.last_course?.cmsgid)
    } else {
      handleExploreCourses()
    }
  }

  useEffect(() => {
    if (isCompleted) {
      trackInternalEvent('progress_score_completed', { score: service.title })
    }
  }, [isCompleted, service.title])

  return (
    <WidgetTheme theme={theme[status]} tipOrder={0}>
      <WidgetContainer>
        <WidgetBox>
          <InfoBox
            text={text}
            bannerType={isProgress ? 'image' : 'text'}
            isCompleted={isCompleted}
            handleClick={handleClick}
            src={service?.data?.last_course?.organisation?.organisation_image}
            data-testid={`upskill-info-${status}`}
            actionButtonTestId={`upskill-action-button-${status}`}
          />
        </WidgetBox>
        <WidgetBox>
          {isCompleted ? (
            <SuccessBox />
          ) : isProgress ? (
            <IlustrationBox
              src={service?.data?.last_course?.small_image}
              percentage={Math.round(service.calculatedProgress.percentageProgress ?? 0)}
            />
          ) : (
            <Styles.Image src={src} data-testid="upskill-illustration-box-initial" />
          )}
        </WidgetBox>
      </WidgetContainer>
    </WidgetTheme>
  )
}
